import styled from 'styled-components';

const VideoContentStyle = styled.div`
	&.videoCont {
		&.full {
			> div {
				padding-top: 59%;
			}
		}

		&.right {
			> div {
				padding-top: 59%;

				@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
					padding-top: 40%;
					text-align: right;

					> div {
						position: absolute;
						top: 0;
						right: 0;
						bottom: 0;
						width: 100%;
						max-width: 68%;
					}
				}
			}
		}

		&.left {
			> div {
				padding-top: 59%;

				@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
					padding-top: 46%;

					> div {
						position: absolute;
						top: 0;
						left: 0;
						bottom: 0;
						width: 100%;
						max-width: 77%;
					}
				}
			}
		}
	}
`;

export default VideoContentStyle;
